import { withDefaults } from '@warp-drive/legacy/model/migration-support';

// API resource: tio-api app/resources/api/v1/history/setting_version_resource.rb (tio-api#10513).
// The wire type is `setting-versions` — JR demodulizes, so the `History::` namespace does not
// reach the client, matching employee-version / pslf-form-version.
const SettingVersionSchema = withDefaults({
  type: 'setting-version',
  traits: ['version'],
  fields: [],
});

export default SettingVersionSchema;
